// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3vB5h","label":"SetPasswdForm_label__14tZV"};